// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4351":"92b00bd1","5079":"92b00bd1","5669":"92b00bd1"}[chunkId] + ".chunk.css";
};